import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { HashRouter } from 'react-router-dom';
import Router from './Router';
import { ShopProvider } from './context/ShopContext';
import { AuthProvider } from './components/AuthContext';
import { PermissionsProvider } from './context/PermissionsContext'; // ✅ Import Permissions Provider

const authExcludePath = '/api/Login/GetUserLogin';

axios.interceptors.request.use(
  (config) => {
    const isLoginRequest = config.url?.includes(authExcludePath);

    if (!isLoginRequest && config.url?.includes('https://winenew.sipstocks.in/')) {
      // config.url = config.url.replace(
      //   'https://nsip.sipstocks.in/'
      // );
    }

    if (isLoginRequest) {
      return config;
    }

    const tokenString = localStorage.getItem('tokenString');
    if (tokenString) {
      config.headers = {
        ...(config.headers || {}),
        Authorization: `Bearer ${tokenString}`,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HashRouter>
    <AuthProvider>
      <PermissionsProvider>      
        <ShopProvider>
          <Router />
        </ShopProvider>
      </PermissionsProvider>
    </AuthProvider>
  </HashRouter>
);
